module.exports = __webpack_public_path__ + "img/11081146_942711575771297_5340828345805454295_n.88806426.jpg";